import { IRecipient, IRecipientWithPairedDonor } from '@nkr/models/recipient';
import { Alert, Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    recipientWithPairedDonor: IRecipientWithPairedDonor,
    placeHolderRecipient: IRecipient,
    onConfirm: (originalRecipientId: number, replacementRecipientId: number, bridgeDonorId: number) => void,
    onCancel: () => void
}

const ConfirmPairRequest = (props: IProps) => {
    if (props.recipientWithPairedDonor == null || props.placeHolderRecipient == null) {
        return null;
    }

    const handleConfirm = () => {
        props.onConfirm(props.placeHolderRecipient.id, props.recipientWithPairedDonor.id, props.recipientWithPairedDonor.pairedDonorId);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Request to Replace Placeholder with Pair
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' style={{ marginBottom: 0, paddingTop: 7.5, paddingBottom: 7.5 }}>
                    <div style={{ marginBottom: 10 }}>The following request will be sent to the NKR operations group for review:</div>
                    <ul style={{ marginBottom: 10 }}>
                        <li style={{ marginBottom: 5 }}>Recipient <strong>{props.placeHolderRecipient.alias}</strong> will be removed from the list.</li>
                        <li style={{ marginBottom: 5 }}>Recipient <strong>{props.recipientWithPairedDonor.alias}</strong> will be assigned to position <strong>{props.placeHolderRecipient.position}</strong>.</li>
                        <li>Paired Donor <strong>{props.recipientWithPairedDonor.pairedDonorAlias}</strong> will be added to position <strong>{props.placeHolderRecipient.position + 1}</strong>.</li>
                    </ul>
                    <div style={{ fontSize: 16, textAlign: 'center' }}><strong>Are you sure you would like to proceed?</strong></div>
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleConfirm}>Yes, Submit Request</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmPairRequest;